import { render } from "./NotFoundForms.vue?vue&type=template&id=f949d1c8&scoped=true"
import script from "./NotFoundForms.vue?vue&type=script&lang=js"
export * from "./NotFoundForms.vue?vue&type=script&lang=js"

import "./NotFoundForms.vue?vue&type=style&index=0&id=f949d1c8&scoped=true&lang=css"

import exportComponent from "/home/hakii/application-form-proto-admin-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f949d1c8"]])

export default __exports__